import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject, Subscription } from "rxjs";
import { AdminService } from "src/app/services/admin.service";

@Component({
  selector: "app-pagination",
  templateUrl: "./pagination.component.html",
  styleUrls: ["./pagination.component.scss"],
})
export class PaginationComponent implements OnInit, OnDestroy {
  @Input() currentPage: number = 1;
  @Input() lastPage: number;
  @Input() filterData;

  @Output() getUpdatedData = new EventEmitter<any>();

  public page = new Subject();
  private pageSubscription: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.page.next(this.currentPage);
    this.pageSubscription = this.page.subscribe((value: number) => {
      if (value !== this.currentPage) {
        this.currentPage = value;
        this.getUpdatedData.emit(this.currentPage);
      }
    });

    this.filterData["page"] = this.currentPage;
    this.updateUrl();
  }

  private getDataWithoutEmptyValues(value: any): any {
    const formatData = {};
    Object.keys(value).forEach((item) => {
      if (value[item] !== "") {
        formatData[item] = value[item];
      }
    });
    return formatData;
  }

  private updateUrl(): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: this.getDataWithoutEmptyValues(this.filterData),
      queryParamsHandling: "", // remove to replace all query params by provided
    });
  }

  goToSpecificPage(page: number): void {
    this.page.next(page);
  }

  goToNextPage(): void {
    if (this.currentPage < this.lastPage) {
      this.page.next(this.currentPage + 1);
    }
  }

  goToPreviousPage(): void {
    if (this.currentPage > 1) {
      this.page.next(this.currentPage - 1);
    }
  }

  goToFirstPage(): void {
    this.page.next(1);
  }

  goToLastPage(): void {
    this.page.next(this.lastPage);
  }

  showPaginationNumber(page: number): boolean {
    return (
      page === this.currentPage - 1 ||
      page === this.currentPage ||
      page === this.currentPage + 1
    );
  }

  get totalPages(): Array<number> {
    const data = [];
    for (let i = 1; i <= this.lastPage; i++) {
      data.push(i);
    }
    return data;
  }

  ngOnDestroy() {
    if (this.pageSubscription) this.pageSubscription.unsubscribe();
  }
}
